import { render, staticRenderFns } from "./indoor.vue?vue&type=template&id=35f1d3ce"
import script from "./indoor.vue?vue&type=script&lang=js"
export * from "./indoor.vue?vue&type=script&lang=js"
import style0 from "./indoor.vue?vue&type=style&index=0&id=35f1d3ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports